<template>
  <div id="contenedor-contratista-listado-contratos">
    <v-data-table
      :headers="headers"
      :items="listadoContratos"
      :items-per-page="20"
      >
      <template v-slot:[`item.contrato.numero`]="{ item }">
        <router-link
          class="font-weight-bold"
          :to="{ name: 'contratistaContratoGenerales',
          params: { idContrato: item.contrato.id } }"
        >
          {{ item.contrato.numero }}
        </router-link>
      </template>
      <template v-slot:[`item.contrato.meta`]="{ item }">
        <cortar-texto
          :texto="item.contrato.meta">
        </cortar-texto>
      </template>
      <template v-slot:[`item.contrato.fecha`]="{ item }">
        {{ new Date(`${item.contrato.fecha} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.contrato.importe`]="{ item }">
        <v-chip :color="item.contrato.modificado.importe !== 0 ? 'warning' : 'grey lighten-4'">
          {{ item.contrato.modificado.importe !== 0
          ? (item.contrato.modificado.importe + item.contrato.importe)
          : item.contrato.importe | currency }}
        </v-chip>
      </template>
      <template v-slot:[`item.plazo`]="{ item }">
        <ContratoPlazo
          :fecha-inicio="!item.contrato.modificado.fechaInicio
            ? item.contrato.fechaInicio
            : item.contrato.modificado.fechaInicio"
          :fecha-termino="!item.contrato.modificado.fechaTermino
            ? item.contrato.fechaTermino
            : item.contrato.modificado.fechaTermino">
        </ContratoPlazo>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ContratoPlazo from '@/components/administracion/contratos/ContratoPlazo.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContratistasListadoContratoos',
  components: {
    ContratoPlazo,
    CortarTexto,
  },
  props: {
    listadoContratos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: false,
          value: 'contrato.numero',
        },
        {
          text: 'Objeto', value: 'contrato.meta', sortable: false, width: '400',
        },
        {
          text: 'Contratista',
          value: 'contrato.contratista.nombreRazonSocial',
          sortable: false,
        },
        {
          text: 'Fecha',
          value: 'contrato.fecha',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Importe',
          value: 'contrato.importe',
          align: 'end',
          sortable: false,
        },
        {
          text: 'Plazo',
          value: 'plazo',
          width: '200',
          sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
